import Axios from "axios";

const operatorsForSelect = {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    actions: {
        async loadList ({ state, commit }) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/limits/operators-for-select',
                method: 'GET',
            }).then(resp => {
                commit('SET_LIST', resp.data.map(({label, value, partnerId, partnerName}) => {return {label, value, partnerId, partnerName}}));
                commit('SET_LOADED', true);
            });

            commit('SET_PROMISE', promise);

            return promise;
        },
        async reloadList({ commit, dispatch }) {
            commit('SET_PROMISE', null);
            commit('SET_LOADED', false);

            return dispatch('loadList');
        },
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    getters: {
        list: (state) => state.list,
        loaded: (state) => state.loaded,
    }
};

export default operatorsForSelect;
